import { apiClient } from './api.client'

/** The Super-Admin tenant fields the GENERAL console section edits (TO-125). */
export interface AdminTenantGeneral {
	tenantId: string
	name: string
	slug: string
	/** Default offer lifetime in whole days (1–365); null = offers do not expire by default. */
	defaultExpirationDays: number | null
}

const tenant = (tenantId: string) => `/admin/tenants/${encodeURIComponent(tenantId)}`

/** `GET` / `PATCH /admin/tenants/{tenantId}` — Super-Admin only (TO-306, TO-125). */
export const adminTenantService = {
	get: async (tenantId: string) => (await apiClient.get<AdminTenantGeneral>(tenant(tenantId))).data,
	updateDefaultExpirationDays: async (tenantId: string, defaultExpirationDays: number | null) =>
		(await apiClient.patch<AdminTenantGeneral>(tenant(tenantId), { defaultExpirationDays })).data,
}
